import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=360e3290&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=360e3290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360e3290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('360e3290', component.options)
    } else {
      api.reload('360e3290', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=360e3290&scoped=true&", function () {
      api.rerender('360e3290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Loader.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Loader.vue
// module id = ggO1
// module chunks = 0